import type { FilterValue } from 'antd/es/table/interface';
import { TExtendColumnProps } from './table';
import { IFilter } from 'Domain/Repositories/BaseRepository/BaseRepository';

export const convertToRequestFilter = ({ filters, columns }: { filters: Record<string, FilterValue | null>, columns: TExtendColumnProps[] }) => {
  const filterKeys = Object.keys(filters);
  const filterValues = Object.values(filters);

  return filterKeys.reduce((acc: IFilter[], key, index) => {
    const column = columns.find((column) => column.key === key);
    const _value = filterValues[index];
    let value:  null | string | number | boolean = null;

    if(_value && Array.isArray(_value) && `${_value[0]}`.trim()) {
      value = _value[0] as unknown as string | number | boolean;
    }


    if (column && value) {
      if(`${value}`.length > 1) {
        value = '%' + `${value}`.replace(/%/g, '') + '%';
      }
      acc.push({
        field: column.key,
        value,
      });
    }

    return acc;
  }, []);
}
